/* Drop sold-out lines out of the cart before checkout can trip over them.

   Why this exists: Shopify carts persist for ~2 weeks. A shopper who added something that
   has since sold out gets stopped at checkout by an "Out of stock — items will be removed"
   interstitial. It's correct behaviour, but it lands at the worst possible moment, on a
   product they may not even remember adding, and it reads like the store is broken.

   Sold-out items can't be ADDED (inventory policy is DENY), so the only way one is in the
   cart is that it sold out while sitting there. Removing it silently is the right call —
   the customer never chose to keep it, and the alternative is a wall in front of payment.

   Safety: only removes a line when the variant is explicitly reported unavailable by
   Shopify. Any fetch failure, missing product, or unrecognised variant leaves the line
   ALONE — the failure mode must never be "deleted something the customer wanted". */
(function () {
  if (window.__reCartClean) { return; }
  window.__reCartClean = true;

  var productCache = {};
  var checked = {};        /* line keys already verified good, so we don't re-fetch forever */
  var running = false;

  function getProduct(handle) {
    if (productCache[handle]) { return productCache[handle]; }
    productCache[handle] = fetch('/products/' + handle + '.js', {
      credentials: 'same-origin', headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) { throw new Error('no product'); }
      return r.json();
    });
    return productCache[handle];
  }

  function clean() {
    if (running) { return; }
    running = true;

    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { running = false; return; }

        var pending = cart.items.filter(function (it) { return !checked[it.key]; });
        if (!pending.length) { running = false; return; }

        return Promise.all(pending.map(function (item) {
          return getProduct(item.handle).then(function (product) {
            var variant = null;
            for (var i = 0; i < product.variants.length; i++) {
              if (product.variants[i].id === item.variant_id) { variant = product.variants[i]; break; }
            }
            /* unknown variant -> leave it be, we can't prove it's dead */
            if (!variant) { checked[item.key] = true; return null; }
            if (variant.available) { checked[item.key] = true; return null; }
            return { key: item.key, title: item.product_title || product.title };
          }).catch(function () { return null; });   /* network trouble -> never remove */
        })).then(function (results) {
          var dead = results.filter(Boolean);
          if (!dead.length) { running = false; return; }

          /* remove them one at a time; line keys stay valid across changes */
          var chain = Promise.resolve();
          dead.forEach(function (d) {
            chain = chain.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: d.key, quantity: 0 })
              });
            });
          });

          return chain.then(function () {
            running = false;
            notify(dead);
            /* rebuild the drawer and repaint the tier rail against the new total */
            if (window.theme && theme.cart && theme.cart.getCart) {
              theme.cart.getCart().then(function (c) {
                document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: c } }));
              });
            } else {
              document.dispatchEvent(new CustomEvent('cart:build'));
            }
          });
        });
      })
      .catch(function () { running = false; });
  }

  /* Tell the customer what happened — removing something silently is worse than saying so. */
  function notify(dead) {
    var host = document.querySelector('#CartDrawerForm .drawer__inner') || document.body;
    var el = document.createElement('div');
    el.className = 're-cart-note';
    var names = dead.map(function (d) { return d.title; }).join(', ');
    el.textContent = dead.length === 1
      ? names + ' sold out and was removed from your bag.'
      : names + ' sold out and were removed from your bag.';
    host.insertBefore(el, host.firstChild);
    setTimeout(function () { if (el.parentNode) { el.parentNode.removeChild(el); } }, 9000);
  }

  document.addEventListener('cart:build', function () { setTimeout(clean, 400); });
  if (document.readyState !== 'loading') { setTimeout(clean, 700); }
  else { document.addEventListener('DOMContentLoaded', function () { setTimeout(clean, 700); }); }
})();
